import React, {useMemo} from 'react';
import styled, {useTheme} from "styled-components";
import VenatusAd from "../ad/VenatusAd";
import CRTTier
    from "../Champions/ChampionsContent/ChampionsRank/ChampionsRankingTable/ChampionsRankingTableContent/CRTTier";
import {useSelector} from "react-redux";
import ChampionImageWithLane from "../common/ChampionImageWithLane";
import useChampionFunc from "../../common/hooks/useChampionFunc";
import {threedigits} from "../../function";
import {useTranslation} from "react-i18next";

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  border-bottom: 1px solid ${props => props.theme.color.default_border_color};
`;

const VideoWrapper = styled.div`
  width: 410px;
  height: 230px;
  background-color: #D9D9D9;
`;

const Content = styled.div`
  flex: 1;
  padding: 20px 16px;
`;

const Title = styled.div`
`;
const TitleSpan = styled.span`
  font-weight: 600;
  font-size: 22px;
  color: ${props => props.theme.color.dark_100};
`;
const TitleExtra = styled.div`
  margin-top: 8px;
  margin-bottom: 24px;
`;
const TitleSpanExtra = styled.span`
  font-weight: 500;
  font-size: 14px;
  color: ${props => props.theme.color.dark_200};
  line-height: 1.3;
`;

const LlmHeader = ({pickChampionBuild, currentPickChampion}) => {
    const {t} = useTranslation();
    return (
        <Wrapper>
            <Content>
                <Title>
                    <TitleSpan>{t('llm.header')}</TitleSpan>
                </Title>
                <TitleExtra>
                    <TitleSpanExtra>{t('llm.explain')}</TitleSpanExtra>
                </TitleExtra>
                <ChampionInfoBox pickChampionBuild={pickChampionBuild} currentPickChampion={currentPickChampion}/>
            </Content>
            <VideoWrapper>
                <VenatusAd placementName={'video'}/>
            </VideoWrapper>
        </Wrapper>
    );
};


const ChampionInfoWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px;
  border-radius: 6px;
  border: 1px solid ${props => props.theme.color.default_border_color};
  background-color: ${props => props.theme.color.white_200};

  .imgDiv {
    border-radius: 8px;
    width: 80px;
    height: 80px;
  }

  .imgChamp {
    width: 86px;
    height: 86px;
  }
`;


const HoverBleWrapper = styled(ChampionInfoWrapper)`
  cursor: pointer;
    
    &:hover {
      background-color: ${props => props.theme.color.dark_300};
    }
`;


const EmptyChampion = styled.div`
  width: 80px;
  height: 80px;
  opacity: 0.2;
  background-color: #000;
  border-radius: 8px;
`;

const InfoBox = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;
const InfoBoxTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-left: 10px;
`;
const InfoBoxTitle = styled.span`
  font-weight: 700;
  font-size: 18px;
  color: ${props => props.theme.color.dark_100};
  margin-left: 16px;
`;
const InfoBoxTitleExtra = styled.span`
  font-weight: 500;
  font-size: 12px;
  color: ${props => props.theme.color.dark_200};
  margin-left: 8px;
`;

const InfoItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  height: 48px;
  width: 72px;
  padding-bottom: 5px;
`;

const InfoItemOthers = styled(InfoItem)`
  justify-content: space-between;
  border-left: 1px solid ${props => props.theme.color.dark_300};
`;
const InfoItemWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 8px;
`;
const InfoItemHeader = styled.span`
  font-weight: 500;
  font-size: 12px;
  color: ${props => props.theme.color.dark_200};
  margin-left: 1px;
`;
const CRTTierWrapper = styled.div`
`;
const InfoItemValueSpan = styled.div`
  height: 24px;
  display: flex;
  flex-direction: row;
  align-items: center;
  font-weight: 500;
  font-size: 14px;
  color: ${props => props.theme.color.dark_100};
`;


const ArrowWithTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: 24px;
`;
//챔피언 정보가 없을 때 표시할 빈 값. champion_id 가 0 이면 아래에서 EmptyChampion 을 렌더한다.
const EMPTY_CHAMPION_INFO = {
    champion_tier: 0,
    games: 0,
    pick_rate: 0,
    win_rate: 0,
    rank: 0,
    ban_rate: 0,
    champion_id: 0,
    champion_name: "ㅡ",
    lane_cnt_all: '-'
};

const ChampionInfoBox = ({pickChampionBuild, currentPickChampion}) => {
    const theme = useTheme();
    const {newTabNavigateToBuild} = useChampionFunc()
    const champions = useSelector((state) => state.imageStore.champions);
    const {t} = useTranslation()
    const data = useMemo(() => {
        //라인을 고르기 전에는 pickChampionBuild 가 undefined 다.
        //position 초기값이 "" 라서 build 목록의 find 가 아무 레인과도 매칭되지 않고 undefined 를 돌려준다.
        //정상적인 미선택 상태이므로 예외로 흘리지 않고 빈 값을 바로 반환한다.
        if (!pickChampionBuild) {
            return EMPTY_CHAMPION_INFO
        }

        try {
            const item = pickChampionBuild
            return {
                champion_tier: item.champion_tier,
                games: item.games,
                pick_rate: (item.pick_rate * 100).toFixed(1),
                win_rate: (item.win_rate * 100).toFixed(1),
                rank: item.rank,
                ban_rate: (item.ban_rate * 100).toFixed(1),
                champion_id: currentPickChampion.champion_id,
                champion_name: currentPickChampion.champion_name,
                lane_cnt_all: item.lane_cnt_all
            }
        } catch (e) {
            console.log(e)
            return EMPTY_CHAMPION_INFO
        }

    }, [pickChampionBuild, currentPickChampion]);


    const getValue = (value) => {
        if (!value) {
            return '-'
        }
        return threedigits(value)
    }


    if (!data.champion_id) {
        return (
            <ChampionInfoWrapper>
                <EmptyChampion/>
                <InfoBox>
                    <ArrowWithTitleWrapper>
                        <InfoBoxTitleWrapper>
                            <InfoBoxTitle>
                                ㅡ
                            </InfoBoxTitle>
                            <InfoBoxTitleExtra>
                                {t('llm.selectedChamp')}
                            </InfoBoxTitleExtra>
                        </InfoBoxTitleWrapper>
                    </ArrowWithTitleWrapper>
                    <InfoItemWrapper>
                        <InfoItem>
                            <InfoItemHeader>{t('championDetailBuild.tier')}</InfoItemHeader>
                            <InfoItemValueSpan>ㅡ</InfoItemValueSpan>
                        </InfoItem>
                        <InfoItemOthers>
                            <InfoItemHeader>{t('championDetailBuild.ranks')}</InfoItemHeader>
                            <InfoItemValueSpan>-{t("summoner.graph_grade", {
                                count: 0,
                                ordinal: true
                            })}<InfoItemHeader>/ -</InfoItemHeader></InfoItemValueSpan>
                        </InfoItemOthers>

                        <InfoItemOthers>
                            <InfoItemHeader>{t('championDetailBuild.winRate')}</InfoItemHeader>
                            <InfoItemValueSpan>-<InfoItemHeader>%</InfoItemHeader></InfoItemValueSpan>
                        </InfoItemOthers>

                        <InfoItemOthers>
                            <InfoItemHeader>{t('championDetailBuild.pickRate')}</InfoItemHeader>
                            <InfoItemValueSpan>-<InfoItemHeader>%</InfoItemHeader></InfoItemValueSpan>
                        </InfoItemOthers>

                        <InfoItemOthers>
                            <InfoItemHeader>{t('championDetailBuild.banRate')}</InfoItemHeader>
                            <InfoItemValueSpan>-<InfoItemHeader>%</InfoItemHeader></InfoItemValueSpan>
                        </InfoItemOthers>

                        <InfoItemOthers>
                            <InfoItemHeader>{t('tabs.games')}</InfoItemHeader>
                            <InfoItemValueSpan>-</InfoItemValueSpan>
                        </InfoItemOthers>
                    </InfoItemWrapper>
                </InfoBox>
            </ChampionInfoWrapper>
        )
    }


    return (
        <HoverBleWrapper onClick={() => newTabNavigateToBuild(currentPickChampion)}>
            <ChampionImageWithLane champion_id={data.champion_id} disableScale={true} imgSize={100} disabled={true}/>
            <InfoBox>
                <ArrowWithTitleWrapper>
                    <InfoBoxTitleWrapper>
                        <InfoBoxTitle>
                            {data.champion_name}
                        </InfoBoxTitle>
                        <InfoBoxTitleExtra>
                            {t('llm.selectedChamp')}
                        </InfoBoxTitleExtra>
                    </InfoBoxTitleWrapper>
                    <div>
                        <img src={`${theme.icon.path}/llm/icn_llm_header_arrow.svg`} width={24} height={24} alt={''}/>
                    </div>
                </ArrowWithTitleWrapper>
                <InfoItemWrapper>
                    <InfoItem>
                        <InfoItemHeader>{t('championDetailBuild.tier')}</InfoItemHeader>
                        <CRTTierWrapper>
                            <CRTTier tier={data.champion_tier} width={24} height={24}/>
                        </CRTTierWrapper>
                    </InfoItem>
                    <InfoItemOthers>
                        <InfoItemHeader>{t('championDetailBuild.ranks')}</InfoItemHeader>
                        <InfoItemValueSpan>{getValue(data.rank)}{t("summoner.graph_grade", {
                            count: data.rank,
                            ordinal: true
                        })}<InfoItemHeader>/ {data.lane_cnt_all ? data.lane_cnt_all : champions.length}</InfoItemHeader></InfoItemValueSpan>
                    </InfoItemOthers>

                    <InfoItemOthers>
                        <InfoItemHeader>{t('championDetailBuild.winRate')}</InfoItemHeader>
                        <InfoItemValueSpan>{getValue(data.win_rate)}<InfoItemHeader>%</InfoItemHeader></InfoItemValueSpan>
                    </InfoItemOthers>

                    <InfoItemOthers>
                        <InfoItemHeader>{t('championDetailBuild.pickRate')}</InfoItemHeader>
                        <InfoItemValueSpan>{getValue(data.pick_rate)}<InfoItemHeader>%</InfoItemHeader></InfoItemValueSpan>
                    </InfoItemOthers>

                    <InfoItemOthers>
                        <InfoItemHeader>{t('championDetailBuild.banRate')}</InfoItemHeader>

                        <InfoItemValueSpan>{getValue(data.ban_rate)}<InfoItemHeader>%</InfoItemHeader></InfoItemValueSpan>
                    </InfoItemOthers>

                    <InfoItemOthers>
                        <InfoItemHeader>{t('tabs.games')}</InfoItemHeader>

                        <InfoItemValueSpan>{getValue(data.games)}</InfoItemValueSpan>
                    </InfoItemOthers>
                </InfoItemWrapper>
            </InfoBox>
        </HoverBleWrapper>
    )
}

export default LlmHeader;